module.exports = __webpack_public_path__ + "videos/curtains-video.23e14d5.webm";